var React = require('react');

function InlineSvg (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#F8604A","d":"M26 13c0-7.18-5.82-13-13-13S0 5.82 0 13s5.82 13 13 13 13-5.82 13-13Z","key":0}),React.createElement("path",{"fill":"#fff","d":"M17.55 20.822h-2.622V7.28h-1.321c-2.254 0-3.38 1.127-3.38 2.817 0 1.885.758 2.816 2.448 3.943l1.322.932-3.749 5.828H7.237l3.575-5.265c-2.059-1.495-3.185-2.817-3.185-5.265 0-3.012 2.058-5.07 6.023-5.07h3.9v15.622Z","key":1})]);
}

InlineSvg.defaultProps = {"viewBox":"0 0 26 26"};

module.exports = InlineSvg;

InlineSvg.default = InlineSvg;
